// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// /home/ensapb/site/web/app/themes/ensapb/node_modules/underscore/modules/identity.js
// module id = 44
// module chunks = 0